import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TabState = {
  activeTab: string;
};

const initialState: TabState = {
  activeTab: localStorage.getItem('customer_page') || "Profil",
};

const tabSlice = createSlice({
  name: "tab",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload;
      localStorage.setItem('customer_page', action.payload);
    },
  },
});

export const { setActiveTab } = tabSlice.actions;
export default tabSlice.reducer;